module.exports = __webpack_public_path__ + "static/media/rooms-main-image.1f7d95e9.png";